import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Button, Grid, IconButton } from '@mui/material';
import Typography from '@mui/material/Typography';
import React, { type ReactNode } from 'react';
import { Helmet } from 'react-helmet';
import styles from 'src/LargeVideoPage/LargeVideoPageStyles';

interface MediaPageSkeletonProps {
  title: string;
  onGoBack?: () => void;
  onFwd?: () => void;
  onBack?: () => void;
  fwdDisabled?: boolean;
  backDisabled?: boolean;
  showNavButtons?: boolean;
  children: ReactNode;
}

const MediaPageSkeleton = ({
  onGoBack,
  title,
  onFwd,
  onBack,
  fwdDisabled,
  backDisabled,
  showNavButtons,
  children,
}: MediaPageSkeletonProps): React.JSX.Element => {
  const classes = styles();
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className={classes.largeVideoPage}>
        <div className={classes.backPrevNextButtons}>
          <div className={classes.backTitle}>
            {onGoBack && (
              <Button className={classes.backButton} onClick={onGoBack}>
                <ArrowBackIcon />
              </Button>
            )}
            <Typography className={classes.assetTitle} variant="h2">
              {title}
            </Typography>
          </div>
          {showNavButtons && (
            <div className={classes.prevNextButtons}>
              <IconButton className={classes.prevButton} disabled={backDisabled} onClick={onBack} size="large">
                <KeyboardArrowLeftIcon />
              </IconButton>
              <IconButton className={classes.nextButton} disabled={fwdDisabled} onClick={onFwd} size="large">
                <KeyboardArrowRightIcon id="cyp-media-page-right-next-icon" />
              </IconButton>
            </div>
          )}
        </div>

        <Grid container spacing={2} justifyContent="center" alignItems="flex-start">
          {React.Children.map(children, (child, index) => (
            <Grid item xs={12} md={index === 0 ? 7 : 5}>
              {child}
            </Grid>
          ))}
        </Grid>
      </div>
    </>
  );
};

export default MediaPageSkeleton;
